import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { RootState } from '../../types/store';
import { UserType } from 'sama-shared';

export const TenantPrivateRoute: React.FC = () => {
  const token = useSelector((state: RootState) => state.auth.token);
  const userType = useSelector((state: RootState) => state.auth.userType);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (userType !== UserType.tenant) {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
};

export default TenantPrivateRoute;
